'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

var _UnsafeUrl = require('../UnsafeUrl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validHref(props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];

    if (typeof value !== 'string' || value === '#') {
      return new Error(componentName + ': Invalid href "' + value + '". If provided, the href ' + 'prop must be a valid URL.');
    }

    if ((0, _UnsafeUrl.isUnsafeUrl)(value)) {
      return new Error(componentName + ': href "' + value + '" could be an XSS attack and will be ignored. ' + 'See https://git.hubteam.com/HubSpot/UIComponents/issues/2599');
    }
  }
  return null;
}

var validHrefPropType = (0, _createChainablePropType2.default)(validHref, 'validHref');
exports.default = validHrefPropType;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/utils/propTypes/validHref.js
// module id = 60
// module chunks = 0